import React from 'react';
import { css } from '@emotion/react';

import theme from "../../../theme";
import WritersToolboxLogo from '../../../images/writers-toolbox-logo-grey-blue.png';
import WritersToolboxLogoSmallBreakpoints from '../../../images/writers-toolbox-blue-logo-two-lines.png';
import SignIn from "./SignIn";
import { useAppState } from "core/contexts/AppContext";
import Loading from "core/Components/Utils/Loading";
import Dialog from "core/Components/Dialog/Dialog";
import DialogContent from "core/Components/Dialog/DialogContent";

type Props = {
    onClose: () => void,
}

const LoginDialog: React.FC<Props> = ({ onClose }) => {
    const [appState] = useAppState();

    if (!appState.hasUserBeenLoaded) {
        return <Loading />;
    }

    return (
        <Dialog onClose={onClose} extraStyle={dialogStyles} showCloseButton={false}>
            <DialogContent>
                <img src={WritersToolboxLogo} alt={"Company Logo"} css={logoStyle} />
                <img src={WritersToolboxLogoSmallBreakpoints} alt={"Company Logo"} css={logoStyleSmallBreakpoints} />
                <div css={errorStyles}>Your session has expired</div>
                <SignIn onLoginDialogClose={onClose} />
            </DialogContent>
        </Dialog>
    )
};

const logoStyle = css`
    height: 40px;

    ${theme.breakpoints.down('xs')} {
        display: none;
    }
`;

const logoStyleSmallBreakpoints = css`
    height: auto;
    width: 100%;
    padding: 0 30px;
    margin: 0;

    ${theme.breakpoints.up('sm')} {
        display: none;
    }
`;

const dialogStyles = css`
    min-width: 480px;
    z-index: ${theme.zIndex.zIndexHighest};
    max-height: 100%;

    ${theme.breakpoints.down('xs')} {
        min-width: 368px;
        max-height: 100%;
    }

    @media (max-width: 616px) {
        padding: 24px;
    }
`;

const errorStyles = css`
    margin-top: 10px;
    font-size: 22px;
    font-weight: ${theme.fonts.weights.light};
    color: ${theme.colours.wellRead};

    ${theme.breakpoints.down('xs')} {
        margin-top: 9px;
        margin-left: 20px;
    }
`;

export default LoginDialog;
